import type { DoubleLangCountry, SecondLangCode } from "../AdmissionLetterDoubleLang/admissionLetterDoubleLangRegistry";
import { getAdmissionDoubleLangRegistry } from "../AdmissionLetterDoubleLang/admissionLetterDoubleLangRegistry";

export type InvoiceDoubleLangCountry = DoubleLangCountry;
export type InvoiceSecondLangCode = SecondLangCode;

export const getInvoiceDoubleLangRegistry = (country: InvoiceDoubleLangCountry, secondLang: InvoiceSecondLangCode) =>
  getAdmissionDoubleLangRegistry(country, secondLang);
